import request from 'superagent';
import { adaptiveUrl, gmSessionId } from '../init';
export default function (_ref) {
  var layers = _ref.layers,
      srid = _ref.srid,
      limit = _ref.limit,
      transformQuery = _ref.transformQuery,
      transformRecords = _ref.transformRecords;
  return function internalSearch(query, bbox, callback) {
    var isCancelled = false;
    var r = request.post(adaptiveUrl() + 'WebServices/search/SearchProxy.asmx/Search').send({
      request: {
        q: transformQuery ? transformQuery(query) : query + '*',
        bbox: bbox,
        layers: layers,
        start: 0,
        srsid: srid,
        limit: limit || 100
      }
    }).set('gm_session_id', gmSessionId()).set('Accept', 'application/json');
    r.then(function (res) {
      if (isCancelled) return;
      var response = res.body.d;

      if (response.success) {
        callback(null, transformRecords ? transformRecords(response.records) : response.records, response.total);
      } else {
        console.error(response.exception, response.exceptions);
        callback(new Error('Could not load results'));
      }
    })["catch"](function (err) {
      if (isCancelled) return;
      console.error(err);
      callback(new Error('Communication error'));
    });
    return {
      query: query,
      bbox: bbox,
      cancel: function cancel() {
        isCancelled = true;
        r.abort();
      }
    };
  };
}